import { Divider } from 'primereact/divider';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { SCButton, SCCalendar, SCDropdown, SCFieldset, SCInputMask, SCInputNumber, SCInputText, SCInputTextarea } from '../components';
import { useToast } from '../context/ToastContext';
import api from "../services/api";
import { ALERTAS, SITUACAO_ALUNO } from '../utilities/constantes';
import { useAuth } from '../providers/auth';
import { Parser } from 'expr-eval';

interface Props {
    formula: string;
    nome?: string;
    setConfigFormulasDialog(param: boolean): void;
    reload(): void;
    FormulaVariavel1: string;
    FormulaVariavel2: string;
}

const ConfiguracaoFormulasForm: React.FC<Props> = ({ setConfigFormulasDialog, nome, formula, reload, FormulaVariavel1, FormulaVariavel2 }) => {
    // é utilizado para o cadastro da ajuda da tela (todas as telas devem ter essa informação)
    // por padrão vamos utilizar o mesmo nome do componente
    const tarefa = 'ConfiguracaoFormulasForm';

    const toast = useToast();
    const { periodoSelecionado, usuario } = useAuth();

    const methods = useForm();
    const { handleSubmit, control, formState: { errors }, watch, setValue, getValues, reset } = methods;

    const campos = [
        { value: "NOTAB1", label: "Nota 1ª Avaliação" },
        { value: "RECUPB1", label: "Recuperação 1ª Avaliação" },
        { value: "NOTAB2", label: "Nota 2ª Avaliação" },
        { value: "RECUPB2", label: "Recuperação 2ª Avaliação" },
        { value: "NOTAB3", label: "Nota 3ª Avaliação" },
        { value: "RECUPB3", label: "Recuperação 3ª Avaliação" },
        { value: "NOTAB4", label: "Nota 4ª Avaliação" },
        { value: "RECUPB4", label: "Recuperação 4ª Avaliação" },
        { value: "NOTAB5", label: "Nota 5ª Avaliação" },
        { value: "RECUPB5", label: "Recuperação 5ª Avaliação" },
        { value: "NOTAB6", label: "Nota 6ª Avaliação" },
        { value: "RECUPB6", label: "Recuperação 6ª Avaliação" },
        { value: "NOTARI", label: "Recuperação Intermediária" },
    ]

    const onSubmit = async () => {
        const parser = new Parser();

        const variaveis: Record<string, number> = {};
        campos.forEach(({ value }) => {
            variaveis[value] = 0;
        });

        campos.forEach(({ value }) => {
            const valor = parseFloat(getValues(value));
            if (!isNaN(valor)) {
                variaveis[value] = valor;
            }
        });

        try {
            let formulaAjustada = formula;

            if (formulaAjustada.includes("FORMULAVARIAVEL1")) {
                formulaAjustada = formulaAjustada.replace(/FORMULAVARIAVEL1/g, FormulaVariavel1 || '0');
            }
            if (formulaAjustada.includes("FORMULAVARIAVEL2")) {
                formulaAjustada = formulaAjustada.replace(/FORMULAVARIAVEL2/g, FormulaVariavel2 || '0');
            }

            const expr = parser.parse(formulaAjustada);
            const resultado = expr.evaluate(variaveis);
            setValue('Resultado', resultado.toFixed(2));
        } catch (e: any) {
            toast.showToast({
                severity: 'error',
                summary: 'Erro ao calcular fórmula',
                detail: e?.message || 'Verifique a fórmula e os campos preenchidos.'
            });
        }
    };


    const cancelar = (e: any) => {
        setConfigFormulasDialog(false);
        reset();
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className='pt-2' >
            <div className='grid'>
                <SCFieldset legend='Informe as Notas'>
                    <div className='grid'>
                        {campos.map(({ value, label }) => (
                            <div className="col-2 pt-2" key={value}>
                                <SCInputNumber
                                    control={control}
                                    name={value}
                                    label={label}
                                    style={{ width: '100%' }}
                                    value={0}
                                />
                            </div>
                        ))}
                    </div>
                </SCFieldset>
                <SCFieldset legend='Processamento' className='col-12 mt-3'>
                    <div className="col-12">
                        <SCInputTextarea
                            control={control}
                            name='Formula'
                            label='Fórmula'
                            style={{ width: '100%' }}
                            value={formula}
                            rows={2}
                            disabled
                        />
                    </div>
                    <div className="flex flex-1 px-2">
                        <div className="col-2 pt-4">
                            <SCButton label="Testar a Fórmula" icon="pi pi-check" className="p-button w-100 p-button-success" type='submit' />
                        </div>
                        <div className="col-2">
                            <SCInputText
                                control={control}
                                name='Resultado'
                                label='Resultado'
                                style={{ width: '100%' }}
                                disabled
                            />
                        </div>
                    </div>
                </SCFieldset>

                <Divider />
                <div className="flex flex-1 justify-content-between pt-3 px-2">
                    <SCButton label="Cancelar" icon="pi pi-times" className="p-button w-auto p-button-danger p-button-outlined" type='button' onClick={cancelar} />
                </div>

            </div>

        </form >

    );
};

export default ConfiguracaoFormulasForm;
